module.exports = __webpack_public_path__ + "static/media/7.f9a81640.jpg";